import type { ElementSchemaType } from '@vedalib/editor/lib/brand'

import type { IFieldConfig } from 'components/formKit'

import type { FieldsSchema } from './types'

export const genSchema = <S extends ElementSchemaType, A extends FieldsSchema>(
  _s: S,
  config: FieldsSchema<S> & A,
): FieldsSchema<S> & A => config

export const genBrandField = <D, P>(c: Omit<IFieldConfig<D, P>, '__type' | 'name'>): IFieldConfig =>
  ({ ...c, __type: 'UIField' }) as IFieldConfig
